import { render, staticRenderFns } from "./GridEstablecimiento.vue?vue&type=template&id=0bbabaaa&"
import script from "./GridEstablecimiento.vue?vue&type=script&lang=js&"
export * from "./GridEstablecimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports